import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Award, GraduationCap, Users, Star, HeartHandshake, BookOpen } from "lucide-react";
import { API } from "@/lib/api";

const ICONS = [GraduationCap, Award, Users, Star, HeartHandshake, BookOpen];
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const photoSrc = (d) => (d?.photo_url ? `${BACKEND}${d.photo_url}` : "/images/clinic2.jpg");

export const useDoctor = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/doctor`).then((r) => setD(r.data)).catch(() => {}); }, []);
  return d;
};

export const Doctor = () => {
  const d = useDoctor();
  if (!d) return <section className="min-h-[600px]" data-testid="doctor-profile-loading" />;
  return (
  <section id="doctor" className="mx-auto max-w-7xl overflow-hidden px-6 py-24 lg:px-8" data-testid="doctor-profile-section">
    <div className="grid items-center gap-14 lg:grid-cols-[0.9fr_1.1fr]">
      <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="relative">
        <div className="absolute -inset-2 -rotate-3 rounded-[2.5rem] bg-[#fef7e5] sm:-inset-4" />
        <img src={photoSrc(d)} alt={d.name} data-testid="doctor-photo" className="relative h-[360px] w-full rounded-[2rem] object-cover shadow-xl sm:h-[480px]" />
        <div className="absolute -bottom-6 right-3 rounded-2xl bg-teal-600 px-5 py-4 text-white shadow-xl">
          <p className="font-display text-lg font-semibold" data-testid="doctor-name">{d.name}</p>
          {d.credentials && <p className="text-xs text-teal-100">{d.credentials}</p>}
        </div>
      </motion.div>
      <div>
        <span className="text-xs font-bold uppercase tracking-widest text-teal-600">Meet your child's dentist</span>
        <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl" data-testid="doctor-heading">{d.heading}</h2>
        <div className="mt-6 space-y-4" data-testid="doctor-bio">
          {d.bio.split(/\n\s*\n/).map((p, i) => <p key={i} className="whitespace-pre-line leading-relaxed text-slate-600">{p}</p>)}
        </div>
        <div className="mt-10 grid grid-cols-2 gap-4" data-testid="doctor-stats-counter">
          {d.qualifications.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
            <div key={i} className="rounded-2xl border border-slate-200 bg-white p-5 transition-colors hover:border-teal-300" data-testid="doctor-qualification">
              <Icon className="h-6 w-6 text-[#ff6b6b]" />
              <p className="font-display mt-3 text-xl font-bold text-slate-800">{s.title}</p>
              <p className="text-xs font-semibold text-slate-500">{s.detail}</p>
            </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
  );
};
